import { PlusSquareOutlined } from '@ant-design/icons';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { Card } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { hasCode } from '../../../../ICodeWidget';
import { CustomOptions } from '../../../../select/WidgetSelect';
import { WidgetRepository } from '../../../WidgetRepository';
import { DraggableActionsButton } from '../../../inputs/common/option-list/style/DraggableActionsButton';
import { WidgetOptionStructure } from '../../../inputs/common/option-list/style/WidgetOptionStructure';
import { ITableWidgetCell } from '../ITableCell';

export interface ITableCellDraggableProps {
  cell: ITableWidgetCell;
  handleRemove?: (e: any) => void;
  handleEdit?: (e: any) => void;
}

const LabelCol = styled.div`
  width: 35%;
  padding: 0 4px;
`;

const CodeCol = styled.div`
  width: 30%;
  font-family: monospace;
  font-weight: 600;
  padding: 0 4px;
`;

export function TableCellDraggable(props: ITableCellDraggableProps) {
  const { cell } = props;
  const widget = cell.widget;
  const widgetType = WidgetRepository.find(widget.type)!;

  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: widget.id,
      data: {
        widget,
      },
    });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
      }}
      {...attributes}
    >
      <Card hoverable={isDragging} size="small">
        <WidgetOptionStructure
          listeners={listeners}
          actions={
            <DraggableActionsButton
              onEdit={props.handleEdit}
              onRemove={props.handleRemove}
            />
          }
        >
          <LabelCol>
            <CustomOptions>
              {widgetType.icon ?? <PlusSquareOutlined />}
            </CustomOptions>
          </LabelCol>
          <LabelCol>
            {'label' in widget && (
              <RichTextAdvancedRender
                hasCustomFont
                inline
                text={widget.label}
              />
            )}
          </LabelCol>
          <CodeCol>{hasCode(widget) && widget.code}</CodeCol>
        </WidgetOptionStructure>
      </Card>
    </div>
  );
}
